import { useContext } from "react";
import { EnvironmentCopyPageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(EnvironmentCopyPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
